<script setup lang="ts">
import { computed, ref } from 'vue'
import IconBase from '@/components/base/IconBase.vue'
import IconInfoCircle from '@/components/icons/IconInfoCircle.vue'
import DialogBase from '@/components/base/dialog/DialogBase.vue'

const infoDialogRef = ref<InstanceType<typeof DialogBase> | null>(null)

// Build date từ Vite define
const buildDate = computed(() => {
  return new Date(__BUILD_DATE__).toLocaleString('vi-VN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
})

const licenses = [
  { item: 'GEOINT 3D Extraction Satellite', serialNumber: 'BIN-AT3D-SAT-2025-1042' },
  { item: 'GEOINT 3D Extraction Satellite - INSAR', serialNumber: 'BIN-AT3D-INS-2025-1103' },
  { item: 'GEOINT 3D Extraction Airborne', serialNumber: 'BIN-AT3D-AIR-2025-1078' },
  { item: 'GEOINT 3D CITY', serialNumber: 'BIN-AT3D-CITY-2025-1157' },
  { item: 'GEOINT 3D Visualization and Analysis with DEM Data entire Indonesia', serialNumber: 'BIN-AT3D-VNA-2025-1199' },
]

const handleOpenInfo = () => {
  infoDialogRef.value?.openDialog()
}
</script>

<template>
  <IconBase variant="subtle" tooltip="About" @click="handleOpenInfo">
    <template #icon>
      <IconInfoCircle />
    </template>
  </IconBase>

  <DialogBase
    ref="infoDialogRef"
    title="About Aetos Terra"
    width="850px"
    :hasActions="false"
    :styleCard="{ backgroundColor: '#1C1C1C', border: '1px solid rgba(179, 229, 117, 0.3)' }"
  >
    <template #content>
      <div class="tw:flex tw:flex-col tw:gap-24">
        <!-- Version -->
        <div class="tw:text-center">
          <h2 class="tw:text-4 tw:font-semibold tw:text-brand-mint-green">Aetos Terra © 2025</h2>
        </div>

        <!-- License Table -->
        <div>
          <h3 class="tw:text-3 tw:font-semibold tw:text-white tw:mb-12">License</h3>
          <div style="max-height: 300px; overflow-y: auto;">
            <table style="width: 100%; border-collapse: collapse;">
              <thead>
                <tr style="background-color: rgba(255, 255, 255, 0.05);">
                  <th style="padding: 12px 16px; text-align: left; border-bottom: 1px solid rgba(255, 255, 255, 0.1); font-weight: 600; color: #B3E575;">Item</th>
                  <th style="padding: 12px 16px; text-align: left; border-bottom: 1px solid rgba(255, 255, 255, 0.1); font-weight: 600; color: #B3E575;">Serial Number</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(license, idx) in licenses"
                  :key="idx"
                  :style="{ backgroundColor: idx % 2 === 0 ? 'transparent' : 'rgba(255, 255, 255, 0.02)' }"
                >
                  <td style="padding: 10px 16px; border-bottom: 1px solid rgba(255, 255, 255, 0.05); color: rgba(255, 255, 255, 0.9);">{{ license.item }}</td>
                  <td style="padding: 10px 16px; border-bottom: 1px solid rgba(255, 255, 255, 0.05); color: rgba(255, 255, 255, 0.7); font-family: monospace;">{{ license.serialNumber }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>


        <div class="tw:flex tw:items-center tw:justify-between tw:w-full tw:gap-8 tw:pt-12 tw:border-t tw:border-t-s-d-s-dark-border-default-secondary">
          <!-- User -->
          <div class="tw:flex tw:items-center tw:gap-8">
            <span class="tw:text-2 tw:text-s-d-s-light-text-default-tertiary">User:</span>
            <span class="tw:text-2 tw:text-white tw:font-semibold">Unlimited</span>
          </div>

          <!-- Build Date -->
          <div class="tw:flex tw:items-center tw:gap-8">
            <span class="tw:text-2 tw:text-s-d-s-light-text-default-tertiary">Last Updated:</span>
            <span class="tw:text-2 tw:text-white tw:font-semibold">{{ buildDate }}</span>
          </div>
        </div>
      </div>
    </template>
  </DialogBase>
</template>
